export default {
  namespaced: true,
  state: {
    isVisible: false,
    idItem: '',
    idUserData: ''
  },
  getters: {
    isVisible: state => state.isVisible,
    idItem: state => state.idItem,
    idUserData: state => state.idUserData
  },
  mutations: {
    toggleModal (state) {
      state.isVisible = !state.isVisible
    },
    setIdItem (state, payload) {
      state.idItem = payload
    },
    setIdUserData (state, payload) {
      state.setIdUserData = payload
    }
  },
  actions: {
  }
}
